/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================================
   MOBIEL MENU — modale bottom sheet (gedrag zoals alcanside.com)
   ----------------------------------------------------------------------------
   WAAROM DIT BESTAAT
   Het thema levert `MobileNavigation` (gecompileerd in theme.js) en dat regelt
   openen/sluiten en het in- en uitschuiven van de panelen prima. Wat ontbreekt
   is alles wat een lade tot een *modaal* venster maakt:

     1. Een echte scroll-lock. Het thema zet enkel de body-class
        `no-mobile-scroll`, maar daar bestaat NERGENS een CSS-regel voor
        (gecontroleerd in theme.css en alle liquid-bestanden) en bovendien
        haalt `SearchBar._onFocusOut` die class na 150 ms weer weg bij elke
        klik in het document. Die class is dus dood gewicht; wij regelen de
        lock zelf met inline styles die niemand anders aanraakt.
     2. Escape sluit de lade niet (het inline script onderaan header.liquid
        vangt Escape alleen af voor de DESKTOP-dropdowns).
     3. Er is geen focus-trap: `Accessibility.trapFocus` zit wel in de bundle,
        maar `MobileNavigation` roept het nooit aan.

   AANPAK
   We vervangen of patchen de bundle NIET en koppelen de bestaande listeners
   niet los. We observeren alleen `aria-hidden` op #mobile-menu met een
   MutationObserver — dat is de enige state die het thema publiceert — en
   sluiten uitsluitend door een klik op de bestaande hamburgerknop te
   simuleren. Zo blijft `MobileNavigation.isOpen` altijd in sync en
   implementeren we nul procent van het open/dicht-gedrag opnieuw.
   ========================================================================== */

(function () {
  'use strict';

  // Guard: custom.js kan in de theme-editor of door een app twee keer geladen
  // worden. Dubbele listeners zouden de scroll-lock uit balans brengen.
  if (window.__ledMobileSheet) {
    return;
  }
  window.__ledMobileSheet = true;

  // Het thema verbergt .header__mobile-nav via `.hidden-lap-and-up`, en die
  // regel staat in theme.css onder `@media screen and (min-width: 1000px)`.
  // Daaronder bestaat de lade dus wél, daarboven niet. Niet gokken op 768px.
  var DESKTOP_QUERY = '(min-width: 1000px)';

  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'summary',
    'iframe',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    '[tabindex]:not([tabindex^="-"])'
  ].join(',');

  var desktopQuery = window.matchMedia(DESKTOP_QUERY);
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --------------------------------------------------------------------------
     1. SCROLL-LOCK
     iOS Safari negeert `overflow: hidden` op body, daarom de enige methode die
     daar wél werkt: body op `position: fixed` met een negatieve top gelijk aan
     de huidige scrollpositie. Visueel verandert er niets, maar er valt niets
     meer te scrollen. Bij het ontgrendelen zetten we de scrollpositie exact
     terug — anders springt de bezoeker naar boven.

     We bewaren de vorige *inline* waarden en zetten die letterlijk terug, zodat
     we niets van het thema of van apps overschrijven. Bewust géén class: die
     zou door SearchBar of een app weggehaald kunnen worden.
     ------------------------------------------------------------------------ */
  var scrollLock = {
    active: false,
    offset: 0,
    body: null,
    html: null
  };

  function lockScroll() {
    if (scrollLock.active) {
      return;
    }

    var body = document.body;
    var html = document.documentElement;

    scrollLock.offset = window.pageYOffset || html.scrollTop || 0;

    // Zodra body fixed wordt verdwijnt de scrollbar (op tablets zichtbaar);
    // die breedte compenseren we zodat de layout niet zijwaarts verspringt.
    var scrollbarWidth = window.innerWidth - html.clientWidth;

    scrollLock.body = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      paddingRight: body.style.paddingRight
    };
    scrollLock.html = {
      scrollBehavior: html.style.scrollBehavior
    };

    // Een eventuele `scroll-behavior: smooth` zou het terugzetten van de
    // scrollpositie animeren; dat is precies wat we niet willen.
    html.style.scrollBehavior = 'auto';

    body.style.position = 'fixed';
    body.style.top = -scrollLock.offset + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';

    if (scrollbarWidth > 0) {
      body.style.paddingRight = scrollbarWidth + 'px';
    }

    scrollLock.active = true;
  }

  function unlockScroll() {
    if (!scrollLock.active) {
      return;
    }

    var body = document.body;
    var html = document.documentElement;

    body.style.position = scrollLock.body.position;
    body.style.top = scrollLock.body.top;
    body.style.left = scrollLock.body.left;
    body.style.right = scrollLock.body.right;
    body.style.width = scrollLock.body.width;
    body.style.paddingRight = scrollLock.body.paddingRight;

    // Direct terugspringen, nooit geanimeerd — ook los van prefers-reduced-motion.
    window.scrollTo(0, scrollLock.offset);

    html.style.scrollBehavior = scrollLock.html.scrollBehavior;

    scrollLock.active = false;
  }

  /* --------------------------------------------------------------------------
     2. ZICHTBAARHEIDSTEST VOOR DE FOCUS-TRAP
     De lade is dynamisch: gesloten panelen staan op `visibility: hidden` en
     ingeklapte submenu's op `height: 0; overflow: hidden`. Zulke elementen zijn
     technisch nog focusbaar, dus Tab zou "verdwijnen" naar onzichtbare links.
     Daarom testen we per kandidaat de daadwerkelijk berekende stijl in plaats
     van een lijst bij te houden.
     ------------------------------------------------------------------------ */
  function isVisiblyFocusable(element, root) {
    // Geen layout-boxen = display:none (of een voorouder daarvan).
    if (!element.getClientRects().length) {
      return false;
    }

    // visibility erft, dus dit vangt alles binnen een dichtgeschoven paneel.
    if (window.getComputedStyle(element).visibility === 'hidden') {
      return false;
    }

    // Dichtgeklapte containers (hoogte 0 + overflow verborgen) hebben nog wel
    // zichtbare kinderen volgens de browser; handmatig uitsluiten dus.
    var parent = element.parentElement;

    while (parent && parent !== root) {
      var parentStyle = window.getComputedStyle(parent);

      if (
        parentStyle.display !== 'inline' &&
        parentStyle.overflow !== 'visible' &&
        (parent.clientHeight === 0 || parent.clientWidth === 0)
      ) {
        return false;
      }

      parent = parent.parentElement;
    }

    return true;
  }

  /* --------------------------------------------------------------------------
     3. DE CONTROLLER PER LADE
     ------------------------------------------------------------------------ */
  var instances = [];

  // Bewust een WeakSet en geen data-attribuut: de theme-editor vervangt de
  // sectie-HTML, en een attribuut dat wij aan de DOM toevoegen zou in zo'n
  // gekopieerde markup kunnen blijven staan waardoor de nieuwe lade nooit
  // geïnitialiseerd wordt. Een WeakSet kent alleen de échte oude knopen.
  var initialised = new WeakSet();

  function MobileSheet(nav) {
    this.nav = nav;
    this.menu = nav.querySelector('.mobile-menu');

    if (!this.menu) {
      return;
    }

    // Zelfde manier van zoeken als MobileNavigation zelf gebruikt.
    this.toggle =
      nav.querySelector('[data-action="toggle-menu"][aria-controls="' + this.menu.id + '"]') ||
      nav.querySelector('[data-action="toggle-menu"]');

    if (!this.toggle) {
      return;
    }

    this.isOpen = this.menu.getAttribute('aria-hidden') === 'false';

    this._onMutation = this._onMutation.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onBreakpointChange = this._onBreakpointChange.bind(this);

    // aria-hidden is de enige toestand die het thema publiceert: observeren in
    // plaats van dupliceren. Zo werken ook sluitingen die wij niet initiëren
    // (klik buiten de nav, klik op de hamburger) automatisch mee.
    this.observer = new MutationObserver(this._onMutation);
    this.observer.observe(this.menu, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });

    document.addEventListener('keydown', this._onKeydown);

    // Bubble-fase op de nav, net als het thema: onze handler draait daardoor ná
    // die van het thema, wat dubbel toggelen uitsluit.
    this.nav.addEventListener('click', this._onClick);

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', this._onBreakpointChange);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(this._onBreakpointChange);
    }

    // Mocht de lade bij het initialiseren al openstaan (theme-editor die de
    // sectie opnieuw rendert), dan meteen vergrendelen.
    if (this.isOpen) {
      this._onOpen();
    }

    this.ready = true;
  }

  MobileSheet.prototype.destroy = function () {
    if (this.observer) {
      this.observer.disconnect();
    }

    document.removeEventListener('keydown', this._onKeydown);
    this.nav.removeEventListener('click', this._onClick);

    if (desktopQuery.removeEventListener) {
      desktopQuery.removeEventListener('change', this._onBreakpointChange);
    } else if (desktopQuery.removeListener) {
      desktopQuery.removeListener(this._onBreakpointChange);
    }

    initialised.delete(this.nav);

    if (this.isOpen) {
      unlockScroll();
    }
  };

  /**
   * Sluiten doen we NOOIT zelf: we simuleren een klik op de hamburger, zodat
   * `MobileNavigation._toggleMenu` draait en zijn eigen `isOpen` bijwerkt.
   * De gesimuleerde klik bubbelt ook naar documentElement, maar de
   * outside-click-handler van het thema ziet dan een target binnen de nav én
   * `isOpen === false`, dus die doet niets.
   */
  MobileSheet.prototype.close = function () {
    if (this.menu.getAttribute('aria-hidden') === 'false') {
      this.toggle.click();
    }
  };

  MobileSheet.prototype._onMutation = function () {
    var open = this.menu.getAttribute('aria-hidden') === 'false';

    if (open === this.isOpen) {
      return;
    }

    this.isOpen = open;

    if (open) {
      this._onOpen();
    } else {
      this._onClose();
    }
  };

  MobileSheet.prototype._onOpen = function () {
    lockScroll();

    // Safari geeft een <button> geen focus bij een klik. Expliciet focussen is
    // dus nodig, anders begint Tab onderaan de pagina in plaats van in de lade.
    // preventScroll omdat de knop toch al in de sticky header staat.
    this.toggle.focus({ preventScroll: true });
  };

  MobileSheet.prototype._onClose = function () {
    unlockScroll();

    // Het thema haalt bij het sluiten wél `.is-open` van alle panelen (dus de
    // lade opent altijd op niveau 1), maar laat `aria-expanded="true"` staan op
    // de knoppen die die panelen openden. Voor een schermlezer stond het menu
    // daardoor bij de volgende opening "uitgeklapt". Opruimen dus.
    var expanded = this.menu.querySelectorAll('[data-action="open-panel"][aria-expanded="true"]');

    for (var i = 0; i < expanded.length; i++) {
      expanded[i].setAttribute('aria-expanded', 'false');
    }

    // Panelen zijn scrollcontainers; hun scrollpositie overleeft het sluiten,
    // waardoor de lade halverwege de lijst heropende.
    var panels = this.menu.querySelectorAll('.mobile-menu__panel');

    for (var j = 0; j < panels.length; j++) {
      panels[j].scrollTop = 0;
    }

    // Focus terug naar de hamburger, maar alleen als de focus nog in de lade
    // zat (of nergens). Sloot de lade doordat iemand buiten de nav klikte —
    // bijvoorbeeld in de zoekbalk — dan mogen we die focus niet afpakken.
    var active = document.activeElement;

    if (!active || active === document.body || this.nav.contains(active)) {
      this.toggle.focus({ preventScroll: true });
    }
  };

  /**
   * Escape sluit de lade. We roepen bewust geen preventDefault/stopPropagation
   * aan: het inline script onderaan header.liquid luistert óók op Escape, maar
   * dat zoekt alleen naar `.nav-bar__item.is-dropdown-open` (desktop) en vindt
   * hier niets. Geen conflict, geen dubbele afhandeling.
   */
  MobileSheet.prototype._onKeydown = function (event) {
    if (!this.isOpen) {
      return;
    }

    if (event.key === 'Escape' || event.key === 'Esc') {
      this.close();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    var focusable = this._focusableElements();

    if (!focusable.length) {
      return;
    }

    // We nemen Tab volledig over in plaats van alleen bij de eerste/laatste te
    // corrigeren. Dat is hier noodzakelijk: als een subpaneel openschuift blijft
    // het paneel eronder gewoon zichtbaar en dus focusbaar (het wordt alleen
    // overdekt). Met de standaard-Tab liep de focus daar dan doorheen.
    event.preventDefault();

    var index = focusable.indexOf(document.activeElement);
    var next;

    if (index === -1) {
      // Focus stond buiten de lade of in een net dichtgeschoven paneel.
      next = event.shiftKey ? focusable[focusable.length - 1] : focusable[0];
    } else {
      next = focusable[(index + (event.shiftKey ? -1 : 1) + focusable.length) % focusable.length];
    }

    this._focus(next);
  };

  /**
   * Klik op de achtergrond sluit de lade.
   *
   * De outside-click-handler van het thema (op documentElement) sluit alleen
   * als het klikdoel BUITEN .header__mobile-nav ligt. Zodra de lade een
   * schermvullende, vastgezette sheet is, ligt de verduisterde achtergrond
   * binnen #mobile-menu en dus binnen de nav — het thema sluit dan niet.
   * Vandaar deze aanvulling: alles wat binnen het menu ligt maar buiten
   * .mobile-menu__inner (de sheet zelf) telt als achtergrond.
   */
  MobileSheet.prototype._onClick = function (event) {
    if (!this.isOpen || !this.menu.contains(event.target) || !event.target.closest) {
      return;
    }

    var target = event.target;

    // Deze handler draait ná die van het thema (beide bubble-fase op de nav),
    // dus .is-open staat er hier al op / af.
    var opener = target.closest('[data-action="open-panel"]');

    if (opener) {
      // getElementById en niet querySelector('#'+id): geen selector-parsing,
      // dus geen exceptie als een menutitel ooit een raar id oplevert.
      this._focusPanelEntry(document.getElementById(opener.getAttribute('aria-controls')));
      return;
    }

    var closer = target.closest('[data-action="close-panel"]');

    if (closer) {
      var leftPanel = closer.closest('.mobile-menu__panel');

      if (leftPanel) {
        var trigger = this.menu.querySelector('[aria-controls="' + leftPanel.id + '"]');

        if (trigger) {
          trigger.focus({ preventScroll: true });
        }
      }

      return;
    }

    // Alles binnen het menu maar buiten .mobile-menu__inner is achtergrond.
    if (!target.closest('.mobile-menu__inner')) {
      this.close();
    }
  };

  /**
   * Een paneel dat openschuift dekt het vorige alleen maar af; dat blijft
   * zichtbaar en focusbaar. Zonder de focus mee te verplaatsen zou hij op een
   * knop blijven staan die de bezoeker niet meer ziet. De terugknop is het
   * eerste element van het nieuwe paneel en geeft meteen context.
   * Het thema onderdrukt focusringen voor muis-/aanraakgebruikers via
   * `body:not(.is-tabbing)`, dus dit levert geen ongewenste rand op.
   */
  MobileSheet.prototype._focusPanelEntry = function (panel) {
    if (!panel) {
      return;
    }

    var entry = panel.querySelector('[data-action="close-panel"]');

    if (!entry) {
      var candidates = panel.querySelectorAll(FOCUSABLE_SELECTOR);

      for (var i = 0; i < candidates.length && !entry; i++) {
        if (isVisiblyFocusable(candidates[i], this.menu)) {
          entry = candidates[i];
        }
      }
    }

    if (!entry) {
      return;
    }

    entry.focus({ preventScroll: true });

    // Het paneel gaat van `visibility: hidden` naar `visible` via een
    // transition. Op het moment van de klik (voortgang 0) is de berekende
    // waarde nog `hidden`, beschouwt de browser het element als niet-focusbaar
    // en negeert focus() stilletjes. Eén frame later is het wél zichtbaar.
    // Zonder transitie (o.a. bij prefers-reduced-motion) lukt de eerste poging
    // meteen en slaan we de herkansing over.
    if (document.activeElement !== entry) {
      window.requestAnimationFrame(function () {
        entry.focus({ preventScroll: true });
      });
    }
  };

  /**
   * Bij een draai naar desktopformaat verbergt het thema de hele nav
   * (`display: none`), maar het menu blijft `aria-hidden="false"` en de body
   * zou dus vergrendeld blijven op een pagina zonder zichtbaar menu.
   */
  MobileSheet.prototype._onBreakpointChange = function () {
    if (desktopQuery.matches && this.isOpen) {
      this.close();
    }
  };

  /**
   * De trap omvat de hamburger (die fungeert als sluitknop en buiten
   * #mobile-menu staat) plus het paneel dat op dit moment in beeld is.
   * Panelen zijn siblings in de DOM en worden per niveau gerenderd, dus het
   * laatste paneel met `.is-open` is het diepste.
   */
  MobileSheet.prototype._focusableElements = function () {
    var result = [];

    if (!this.toggle.disabled) {
      result.push(this.toggle);
    }

    var openPanels = this.menu.querySelectorAll('.mobile-menu__panel.is-open');
    var panel = openPanels.length
      ? openPanels[openPanels.length - 1]
      : this.menu.querySelector('.mobile-menu__panel:not(.is-nested)');

    if (!panel) {
      return result;
    }

    var candidates = panel.querySelectorAll(FOCUSABLE_SELECTOR);

    for (var i = 0; i < candidates.length; i++) {
      if (isVisiblyFocusable(candidates[i], this.menu)) {
        result.push(candidates[i]);
      }
    }

    return result;
  };

  MobileSheet.prototype._focus = function (element) {
    // Zelf scrollen zodat we het gedrag kunnen afstemmen op de
    // toegankelijkheidsvoorkeur van de bezoeker.
    element.focus({ preventScroll: true });

    if (element.scrollIntoView) {
      element.scrollIntoView({
        block: 'nearest',
        behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'
      });
    }
  };

  /* --------------------------------------------------------------------------
     4. INITIALISATIE
     ------------------------------------------------------------------------ */
  function init() {
    // Opruimen van instanties waarvan de sectie opnieuw gerenderd is.
    for (var i = instances.length - 1; i >= 0; i--) {
      if (!document.documentElement.contains(instances[i].nav)) {
        instances[i].destroy();
        instances.splice(i, 1);
      }
    }

    var navs = document.querySelectorAll('.header__mobile-nav');

    for (var j = 0; j < navs.length; j++) {
      // Dubbele initialisatie voorkomen (shopify:section:load kan meerdere
      // keren vuren voor secties die de header bevatten).
      if (initialised.has(navs[j])) {
        continue;
      }

      var instance = new MobileSheet(navs[j]);

      // Zonder menu of hamburgerknop is er niets te beheren (bijvoorbeeld op
      // pagina's waar de header anders is opgebouwd).
      if (instance.ready) {
        initialised.add(navs[j]);
        instances.push(instance);
      }
    }
  }

  init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    // De lade kan met een geopende (en dus vergrendelde) body verdwijnen.
    unlockScroll();
    init();
  });
})();
